<template>
    <b-container>
        <!-- Fake call to setup orders -->
        {{setupOrders}}
        <div>
            <b-row>
                <b-col>
                    <h4 style="color:#2e5189; margin-top:20px">PURCHASE ORDER</h4>
                </b-col>
            </b-row>

            <!-- Buyer Name -->
            <b-row>
                <b-col>
                    <h5 style="color:#2e5189">Bill To</h5>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h5 style="color:#2e5189; text-indent:20px">{{ordersObject.pub}}</h5>
                </b-col>
            </b-row>
            <!-- Buyer Address -->
            <b-row>
                <b-col style="text-indent:20px">
                    Address: <span style="font-weight:bold; color:#2e5189">{{ordersObject.billingaddress}}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col style="text-indent:20px">
                    Order Date: <span style="font-weight:bold; color:#2e5189">{{ordersObject.date}}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col style="text-indent:20px">
                    Order Number: <span style="font-weight:bold; color:#2e5189">{{ordersObject.mainorderid}}</span>
                </b-col>
            </b-row>
            <hr>
            <!-- Seller address -->
            <b-row>
                <b-col>
                    <h5 style="color:#2e5189">Invoice From</h5>
                </b-col>
            </b-row>
            <!-- Seller name and address -->
            <b-row>
                <b-col>
                    <h5 style="color:#2e5189; text-indent:20px">{{ordersObject.brewer}}</h5>
                </b-col>
            </b-row>
            <b-row>
                <b-col style="text-indent:20px">
                    <span style="">{{userProfile.street1}}</span>
                </b-col>
            </b-row>
            <b-row v-if="userProfile.street2">
                <b-col style="text-indent:20px">
                    <span style="">{{userProfile.street2}}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col style="text-indent:20px">
                    <span style="">{{userProfile.city}}, {{userProfile.state}}, {{userProfile.zip}}</span>
                </b-col>
            </b-row>

            <!-- Shipping terms -->
            <hr>
            <b-row>
                <b-col>
                    <h5 style="color:#2e5189">Shipping Terms</h5>
                </b-col>
            </b-row>
            <b-row>
                <b-col style="text-indent:20px">
                    <span style="text-indent:20px">{{ordersObject.selectedDeliveryOption}}</span>
                </b-col>
            </b-row>

            <!-- Table of items -->
            <table class="table table-bordered" style="margin-top:10px">
                <thead class="thead-dark">
                    <tr>
                        <th><small>Beverage</small></th>
                        <th><small>Quantity</small></th>
                        <th><small>Container</small></th>
                        <th><small>Cost</small></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="item in ordersObject.cartItems">
                        <tr :key="item.id+item.suborderid">
                            <td>{{item.beerName}}</td>
                            <td>{{item.orderQuantity}}</td>
                            <td>{{item.size}}</td>
                            <td>$ {{item.itemsCost}}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <!-- Costs -->
            <b-row style="text-align:right">
                <b-col>
                    Items Cost: $ {{ordersObject.totalItemsCost}}
                </b-col>
            </b-row>
            <b-row style="text-align:right">
                <b-col>
                    Taxes: $ {{ordersObject.tax.toFixed(2)}}
                </b-col>
            </b-row>
            <!-- Shipping/delivery cost -->
            <b-row v-if="ordersObject.selectedDeliveryOption=='Deliver'" style="text-align:right">
                <b-col>
                    Delivery Cost: $ {{ordersObject.deliveryCost}}
                </b-col>
            </b-row>
            <b-row v-if="ordersObject.selectedDeliveryOption=='Ship'" style="text-align:right">
                <b-col>
                    Shipping Cost: $ {{ordersObject.shippingCost}}
                </b-col>
            </b-row>
            
            <b-row v-if="parseFloat(ordersObject.kegDeposit)>0" style="text-align:right">
                <b-col>
                    Refundable Keg Deposit: $ {{ordersObject.kegDeposit}}
                </b-col>
            </b-row>
            <b-row v-if ="parseFloat(ordersObject.kegDeposit)>0" style="color: red; text-align:right"  class="coststyle">
                <b-col cols='12'>
                    <small>By ordering kegs, you agree that you will return the kegs <br> within 60 days. Otherwise, the keg deposit will be forfeited by you at the seller's discretion</small>
                </b-col>
            </b-row>
            <hr>
            <b-row style="color:green; text-align:right">
                <b-col>
                    <h4>Total Cost: $ {{ordersObject.totalCost.toFixed(2)}}</h4>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <small>An additional $2.99 Keg Seeker fees will be added to the complete order</small>
                </b-col>
            </b-row>
            <hr>
        </div>
    </b-container>
</template>

<script>
    import { mapState } from 'vuex'
    import { currentUser } from '../../firebaseConfig'
    import moment from 'moment'
    const fb = require('../../firebaseConfig.js')
    import Sendmessage from '../Sendmessage'

    export default {
        props: ['ordersObject'],
        components: {
            Sendmessage,
            },
        computed: {
            ...mapState(['userProfile', 'currentUser']),
            setupOrders(){
                console.log("Order = ")
                console.log(this.ordersObject)
                this.itemsCost=this.ordersObject.totalItemsCost
                
                this.shippingCost=this.ordersObject.shippingCost
                this.deliveryCost=this.ordersObject.deliveryCost
                var cartItems = this.ordersObject.cartItems
                this.taxes=(this.itemsCost*parseFloat(this.ordersObject.taxrate)).toFixed(2)
                this.totalCost = parseFloat(this.itemsCost) + parseFloat(this.taxes)
                if(!isNaN(parseFloat(this.ordersObject.kegDeposit))) this.totalCost  = this.totalCost  + parseFloat(this.ordersObject.kegDeposit)
                //Add shipping and delivey cost
                if(this.ordersObject.selectedDeliveryOption=='Ship') this.totalCost = parseFloat(this.totalCost + this.ordersObject.shippingCost).toFixed(2)
                if(this.ordersObject.selectedDeliveryOption=='Deliver') this.totalCost = parseFloat(this.totalCost + this.ordersObject.deliveryCost).toFixed(2)
                
            },
        },

        data() {
            return {
                itemsCost:0,
                shippingCost:0,
                deliveryCost:0,
                taxes:0,
                totalCost:0,
                
            }
        },
        methods: {
            
        }
        
    }
</script>